module.exports = __webpack_public_path__ + "static/media/liquity.c4ca8350.png";